<div
  *ngIf="statusFlag; else noEllipsis"
  class="collapsable-text fixed"
  [ngStyle]="{ 'max-height.px': numberLines * 24 }"
>
  <div
    ellipsis="... Show More"
    [ellipsis-content]="innerText"
    (ellipsis-click-more)="changeStatusFlag()"
    class="collapsable-text break-word-text"
    [ngStyle]="{ 'max-height.px': numberLines * 24 }"
  ></div>
</div>

<ng-template #noEllipsis>
  <div class="innerText pre-wrap-spaces break-word-text">
    {{ innerText }}
    <button type="buttom" class="btn btn-link" (click)="changeStatusFlag()">{{ 'SHOW_LESS' | translate }}</button>
  </div>
</ng-template>
